import {API, Entities} from "../../utils/Api";
import { redirect } from 'react-router-dom';
import {useLoaderData, useNavigate, useParams, useRouteLoaderData, useSearchParams} from "react-router-dom";
import {useState} from "react";
import Cookies from "js-cookie";

export function TicketRequest(){

    const rootLoaderData= useRouteLoaderData('/');
    const [searchParams] = useSearchParams();
    const data = useLoaderData();

    var rebuy = searchParams.get('rebuy');
    var ticket=data.ticket[0];
    var [purchase,setPurchase] = useState(false);

    async function buyTicket(){
        var email = document.getElementById('email').value;
        var name = document.getElementById('name').value;
        try {
            const response = await API.post(Entities.requestTicket, {email: email,name:name}); // Várjuk meg
            const section = document.getElementById('ticketrequest');
            const nav = document.querySelector('nav');
            if (section) {
                // kiszámoljuk a nav magasságát
                const navHeight = nav ? nav.offsetHeight : 0;

                // lekérjük a szekció pozícióját az oldalon
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;

                // smooth scroll nav magasság mínusszal
                window.scrollTo({
                    top: sectionTop - navHeight, // nav magasságával korrekció
                    behavior: 'smooth'
                });
            }
            if(response.status ==1 && response.email ==true) {
                setPurchase(true)
            }
        } catch (error) {
        }
    }

    return (
        <section id={'ticketrequest'} className="bg-very-light-gray2 position-relative">
            <div className="container">
                <div className="row mb-8">
                    <div className="col-xl-5 col-lg-6 md-mb-50px"
                         data-anime={JSON.stringify({
                             "el": "childs",
                             "translateX": [-50, 0],
                             "opacity": [0, 1],
                             "duration": 1200,
                             "delay": 0,
                             "staggervalue": 150,
                             "easing": "easeOutQuad"
                         })}>
                        <div
                            className="bg-very-light-gray border-radius-6px box-shadow-quadruple-large p-10 ps-12 pe-12 lg-ps-8 lg-pe-8 h-100 d-flex flex-wrap flex-column justify-content-center"
                            data-anime='{ "el": "childs", "translateY": [0, 0], "opacity": [0,1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                            <span
                                className="ps-25px pe-25px mb-50px text-uppercase text-base-color fs-12 lh-40 fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-flex justify-content-center"><i
                                className="bi bi-chat-square-dots fs-16 me-5px "></i>JEGYEK LIMITÁLT SZÁMBAN ELÉRHETŐK</span>
                            <h4 className="text-dark-gray ls-minus-1px fw-700 mb-15px text-center">Ár: {new Intl.NumberFormat('hu-HU').format(parseInt(ticket.gross)) } {ticket.currency}</h4>
                            <p className="w-100 sm-w-100 mb-20px mt-10px text-center">{ticket.name}</p>
                            <div className={'row text-start'}>
                                <hr/>
                                <div className="col-12 last-paragraph-no-margin">
                                    <p>AZ ÁR TARTALMAZZA</p>
                                </div>
                                <div className="col-12 text-start last-paragraph-no-margin text-start">
                                    <ul className="lh-1">
                                        <li>• a konferencián való részvételt,</li>
                                        <li>• a Cateringet,
                                            <ul className="ms-1">
                                                <li>• délelőtti kávészünetet,</li>
                                                <li>• ebédet,</li>
                                                <li>• délutáni kávészünetet,</li>
                                            </ul>
                                        </li>
                                        <li>• az ÁFA-t.</li>
                                    </ul>
                                </div>
                            </div>

                            <hr/>
                            <div className="row row-cols-1 row-cols-sm-2 text-center">
                                <div className="text-start col lh-1 last-paragraph-no-margin mb-5px">
                                    <p>HELYSZÍN:</p>
                                </div>
                                <div className="col last-paragraph-no-margin lh-1 mb-5px text-start">
                                    <p className={'mb-0'}>Magyar Tudományos Akadémia</p><p>
                                        1051 Budapest, Széchenyi István tér 9</p>
                                </div>
                                <div className="text-start col last-paragraph-no-margin sm-mb-25px">
                                    <p>IDŐPONT</p>
                                </div>
                                <div className="col last-paragraph-no-margin text-start">
                                    <p>2025.05.20.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 offset-xl-1 md-mb-50px sm-mb-0"
                         data-anime={JSON.stringify({
                             "el": "childs",
                             "translateX": [50, 0],
                             "opacity": [0, 1],
                             "duration": 1200,
                             "delay": 0,
                             "staggervalue": 150,
                             "easing": "easeOutQuad"
                         })}>
                        <h3 className="text-dark-gray ls-minus-2px fw-700">Jegyvásárlás</h3>
                        {  !purchase && rebuy &&  <div className="alert alert-danger text-white shadow" style={{background:'#ff0000',borderRadius:'6px'}} role="alert">A jegyvásárlási link lejárt, vagy az URL érvénytelen. Kérjük, a vásárlás újraindításához töltse ki az alábbi űrlapot! </div>  }
                        { !purchase && <form className="contact-form-style-03">
                            <p className="mb-0 fs-14 lh-22"
                               style={{textAlign:'justify'}}>
                                Kedves Vendégünk!</p>
                            <p className="mb-0 fs-14 lh-22 mb-3"
                               style={{textAlign:'justify'}}>
                                Köszönjük, hogy érdeklődsz a BeneFit SHARE konferencia iránt.
                                Kérjük add meg e-mail címedet, hogy elküldhessük a jegyvásárlással kapcsolatos részleteket és segítsünk a következő lépésekben.
                                Már nagyon készülünk és alig várjuk, hogy személyesen is találkozzunk – tartalmas előadásokkal, gyakorlati példákkal és izgalmas programmal várunk!
                                Üdvözlettel,
                                a BeneFit SHARE csapata
                            </p>
                            <label htmlFor="name"
                                   className="form-label fs-13 text-uppercase text-dark-gray fw-700 mb-0">Résztvevő
                                Neve*</label>
                            <div className="position-relative form-group mb-20px"><span className="form-icon"><i
                                className="bi bi-emoji-smile text-dark-gray"></i></span>
                                <input
                                    className="fs-15 ps-0 border-radius-0px border-color-dark-gray bg-transparent form-control required"
                                    id="name" type="text" name="name" placeholder="Tejes név"/>
                            </div>
                            <label htmlFor="email"
                                   className="form-label fs-13 text-uppercase text-dark-gray fw-700 mb-0">Email
                                cím*</label>
                            <div className="position-relative form-group mb-20px"><span className="form-icon"><i
                                className="bi bi-envelope text-dark-gray"></i></span>
                                <input
                                    className="fs-15 ps-0 border-radius-0px border-color-dark-gray bg-transparent form-control required"
                                    id="email" type="email" name="email" placeholder="E-mail cím"/>
                            </div>
                            <div className="position-relative form-group form-textarea mb-0"><span
                                className="form-icon"></span>
                            </div>
                            <div className="row mt-25px align-items-center">
                                <div className="col-xl-7 col-lg-12 col-sm-7 lg-mb-30px md-mb-0">
                                    <p className="mb-0 fs-14 lh-22 text-center text-sm-start">A fizetési linket emailben
                                        küldjük ki</p>
                                </div>
                                <div
                                    className="col-xl-5 col-lg-12 col-sm-5 text-center text-sm-end text-lg-start text-xl-end xs-mt-25px">
                                    <input id="exampleInputEmail3" type="hidden" name="redirect" value=""/>
                                    <button className="btn btn-base-color btn-box-shadow btn-round-edge submit"
                                            onClick={buyTicket}>JEGYVÁSÁRLÁSI IGÉNY ELKÜLDÉSE
                                    </button>
                                </div>
                                <div className="col-12 mt-20px mb-0 text-center text-md-start">
                                    <div className="form-results d-none"></div>
                                </div>
                            </div>
                        </form>}
                        { purchase && <h3 className="text-dark-gray ls-minus-2px fw-700">Köszönjük az érdeklődést! A részletekről emailben értesítünk</h3>}
                    </div>
                </div>
            </div>
            <div className="shape-image-animation p-0 w-100 bottom-minus-40px xl-bottom-0px d-none d-md-block">
                <svg xmlns="http://www.w3.org/2000/svg" widht="3000" height="400" viewBox="0 180 2500 200"
                     fill="#ffffff">
                    <path className="st1" d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250">
                        <animate attributeName="d" dur="5s" values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250" repeatCount="indefinite"/>
                    </path>
                </svg>
            </div>
        </section>
    )
}
export async function TicketRequestLoader({ params, request }) {
    const url = new URL(request.url);
    const rebuy = url.searchParams.get('rebuy'); // ha már redirectelve lett

    Cookies.set('jwt', params.purchaseToken);

    // Lekérjük az útvonalat
    const pathname = url.pathname;

    // Csak akkor fut le, ha /jegy/<valami> mintájú az URL
    const isValidPath = /^\/jegy\/[^/]+$/.test(pathname);

    if (isValidPath) {
        try {
            const response = await API.rest(Entities.checkToken, "POST");

            // Ha statusCode létezik, és nem 200-as
            if (response.statusCode && parseInt(response.statusCode) !== 200) {
                // Ha még nem volt redirect, akkor irányítsuk át
                if (!rebuy) {
                    return redirect('/ticket?rebuy=1');
                }
            }
        } catch (error) {
            console.error("Hiba történt az API hívás során (token ellenőrzés):", error);
            return { events: [] };
        }
    }

    try {
        const response = await API.rest(Entities.ticket, "GET");
        return {
            ticket: response,
        };
    } catch (error) {
        console.error("Hiba történt az API hívás során (ticket lekérés):", error);
        return { events: [] };
    }
}